<template>
    <div class="right-sheet-section">
        <div class="right-sheet-section-head">
            <h3 v-if="title">{{ title }}</h3>
            <slot name="view-all">
                <a v-if="showViewAll" @click="viewAll">{{ viewAllText }} &gt;</a>
            </slot>
        </div>
        <hr class="thick" />
        <slot />
    </div>
</template>
<script>
export default {
    name: 'RightSheetSection',
    props: {
        title: {
            type: String,
            required: false,
            default: null,
        },
        viewAllText: {
            type: String,
            required: false,
            default: null,
        },
        hideViewAll: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        showViewAll() {
            return !this.hideViewAll && !!this.viewAllText
        },
    },
    methods: {
        viewAll() {
            this.$emit('viewall')
        },
    },
}
</script>
<style>
.right-sheet-section {
    margin-bottom: 24px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > * {
        width: 100%;
    }

    .right-sheet-section-head {
        a {
            color: var(--color-focus);
            cursor: pointer;
            font-size: var(--font-size-detail);
            font-weight: var(--weight-bold);
            line-height: 24px;
            text-transform: uppercase;
            text-align: right;
            float: right;

            &::hover {
                color: var(--color-active);
            }
        }

        h3 {
            flex: 1;
            float: left;
            margin-bottom: 16px;
        }
    }
}
</style>
